import { atomWithStorage } from 'jotai/utils';

import { Locale, LocalStorageKey } from 'v2/constants';

export const localeAtom = atomWithStorage<Locale>(LocalStorageKey.LOCALE, Locale.ru_RU, undefined, { getOnInit: true });
